<template>
	<div class="disclaimers">
    <h2><Icon icon="disclaimer"></Icon><span v-html="_translate('disclaimers.title')"></span></h2>
		
		<div class="disclaimers__container">

			<div class="disclaimers__wrapper" v-html="outputDisclaimers"></div>
      <div class="disclaimers__wrapper">
        <p class="disclaimers__item"><span v-html="_translate('disclaimers.copyright')"></span> <span class="bar">|</span> 
          <a class="link" :href="_translate('links.disclaimers')" target="_blank">{{ _translate('disclaimers.disclaimers') }}</a> <span class="bar">|</span>
          <a class="link" :href="_translate('links.legal')" target="_blank">{{ _translate('disclaimers.legalText') }}</a> <span class="bar">|</span>
          <a class="link" :href="_translate('links.privacy')" target="_blank">{{ _translate('disclaimers.privacyText') }}</a> <span class="bar">|</span>
          <a class="link" :href="_translate('links.complaint')" target="_blank">{{ _translate('disclaimers.complaintText') }}</a>
        <p class="disclaimers__item disclaimers__item--italic" v-html="_translate('disclaimers.general')"></p>
        <p class="disclaimers__item disclaimers__item--italic" v-html="_translate('disclaimers.general2')"></p>
      </div>

		</div>
		<div class="disclaimers__control">
			<button class="button" @click="acceptDisclaimers()">{{ _translate('disclaimers.acceptButton') }}</button>
		</div>

	</div>
</template>

<script>

import Checkbox from './Checkbox.vue'
import Icon from './Icon.vue'

export default {

  components: {

    Checkbox,
    Icon,

  },

  computed: {

  	outputDisclaimers() {

  		var disclaimers = this.$store.getters.getGlobalDisclaimers.disclaimers,
  		    html = '';

  		for ( var index in disclaimers ) {

  			html += '<h3>' +  this._translate(disclaimers[index].title) + '</h3>';

  			for ( var i in disclaimers[index].list ) {

  				html += '<p class="disclaimers__item">';
  				html += '<span class="term">'
  				html += this._translate(disclaimers[index].list[i].term)
  				html += '</span>'
  				html += ' - '
  				html += this._translate(disclaimers[index].list[i].def)
  				html += '</p>';

  			}

  		}

  		return html;

  	}

  },

  methods: {

  	acceptDisclaimers() {

  		this.$store.dispatch('closeModal');

  	},

  }

}

</script>

<style lang="scss">

	.disclaimers {

		height: 100%;

	}

  .disclaimers__container {

    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;

    height: calc(100% - 8rem);

    > * {

    	width: 100%;

    }

  }

  .disclaimers__control {

    width: 100%;

  }

  .disclaimers__wrapper {

  	:first-child {

  		margin-top: 0;

  	}

  }

  .disclaimers__item {

		.term {

			font-weight: 700;

		}

    .bar {
      color: #aaa;
      padding: 0 10px;
    }

    .link {
      color: #06a0df;

      &:link,
      &:visited {
        text-decoration: none;
      }

      &:hover,
      &:focus,
      &:active {
        text-decoration: underline;
      }
    }

  }

  .disclaimers__item--italic {
    font-style: italic;
  }

</style>


// WEBPACK FOOTER //
// Disclaimers.vue?12e0d7a5